import TicketDetail from '../TicketDetail';

export default function HRManagerEscalationDetail() {
  return <TicketDetail />;
}
